/* eslint-disable import/prefer-default-export */
import _ from "lodash";
import AppConfig from "../config/AppConfig";
import { isEmpty } from "../common/Common";
import moment from "moment";

export const setRulesData = (data = [], config = {}, previousConfig = {}, currentOrg="") => {
  data.forEach((rule) => {
    config[rule.rule_type] = {};
    previousConfig[rule.rule_type] = {};
    const subConfig = {};
    rule.configurations.forEach((setting) => {
      subConfig[setting.setting_name] = setting.setting_value;
      previousConfig[rule.rule_type][setting.setting_name] =
        setting.setting_value;
      if (
        rule.rule_type === "org_group_accounts" &&
        !isEmpty(subConfig.group_accounts) &&
        _.isString(subConfig.group_accounts) &&
        subConfig.group_accounts === "[]"
      ) {
        subConfig.group_accounts = [];
        previousConfig[rule.rule_type].group_accounts = [];
      }
      if (
        rule.rule_type === "org_billing_rules" &&
        !isEmpty(subConfig.require_prefix_for_invoice) &&
        subConfig.group_accounts === "true"
      ) {
        if (isEmpty(subConfig.no_of_chars_for_invoice_no)) {
          subConfig.no_of_chars_for_invoice_no = "ALL";
          previousConfig[rule.rule_type].no_of_chars_for_invoice_no = "ALL";
        }
        if(isEmpty(subConfig.round_off_decimals)){
          subConfig.round_off_decimals = AppConfig.default_decimal_points;
          previousConfig[rule.rule_type].round_off_decimals =  AppConfig.default_decimal_points;
        }
      }
      if (
        rule.rule_type === "org_billing_rules"
      ) {
        if(isEmpty(subConfig.start_driver_settlements_on)){
          subConfig.start_driver_settlements_on = 'BILLING_APPROVAL';
          previousConfig[rule.rule_type].start_driver_settlements_on =  'BILLING_APPROVAL';
        }
        if(isEmpty(subConfig.round_off_decimals)){
          subConfig.round_off_decimals = AppConfig.default_decimal_points;
          previousConfig[rule.rule_type].round_off_decimals =  AppConfig.default_decimal_points;
        }
        if(isEmpty(subConfig.move_unsatisfied_orders_to_unassigned)){
          subConfig.move_unsatisfied_orders_to_unassigned = "false";
          previousConfig[rule.rule_type].move_unsatisfied_orders_to_unassigned =  false;
          subConfig.unsatisfied_orders_to_unassigned_apply_for = "";
          previousConfig[rule.rule_type].unsatisfied_orders_to_unassigned_apply_for =  "";
        }else {
          if(
          subConfig.move_unsatisfied_orders_to_unassigned === 'true' && 
          isEmpty(subConfig.unsatisfied_orders_to_unassigned_apply_for)){
            subConfig.unsatisfied_orders_to_unassigned_apply_for = "AUTO_PREPLAN";
            previousConfig[rule.rule_type].unsatisfied_orders_to_unassigned_apply_for =  "AUTO_PREPLAN";
          }
        }
        if(isEmpty(subConfig.invoice_header_address)){
          subConfig.invoice_header_address = "ORG";
          previousConfig[rule.rule_type].invoice_header_address =  "ORG";
        }
        if(isEmpty(subConfig.require_driver_effort_insertion)){
          subConfig.require_driver_effort_insertion = "true";
          previousConfig[rule.rule_type].require_driver_effort_insertion =  "true";
        }
        if (isEmpty(subConfig.send_invoice_to_driver_after_invoice_approval)) {
          subConfig.send_invoice_to_driver_after_invoice_approval = "true";
          previousConfig[rule.rule_type].send_invoice_to_driver_after_invoice_approval = "true";
        }
        if (isEmpty(subConfig.invoice_number_length_type)) {
          subConfig.invoice_number_length_type = "with_account_code";
          previousConfig[rule.rule_type].invoice_number_length_type = "with_account_code";
        }
        if (isEmpty(subConfig.invoice_no_start_type)) {
          subConfig.invoice_no_start_type = "start_from_digit";
          previousConfig[rule.rule_type].invoice_no_start_type = "start_from_digit";
        }
        if (isEmpty(subConfig.create_manual_billing)) {
          subConfig.create_manual_billing = "true";
          previousConfig[rule.rule_type].create_manual_billing = "true";
        }
        if (isEmpty(subConfig.enable_invoice_charges_tab)) {
          subConfig.enable_invoice_charges_tab = "false";
          previousConfig[rule.rule_type].enable_invoice_charges_tab = "false";
        }
        if (isEmpty(subConfig.invoice_email_notification_logo_height)) {
          subConfig.invoice_email_notification_logo_height = "70";
          previousConfig[rule.rule_type].invoice_email_notification_logo_height = "70";
        }
        if (isEmpty(subConfig.invoice_email_notification_logo_width)) {
          subConfig.invoice_email_notification_logo_width = "200";
          previousConfig[rule.rule_type].invoice_email_notification_logo_width = "200";
        }
        if (isEmpty(subConfig.ask_to_provide_invoice_no_upon_billing_approval)) {
          subConfig.ask_to_provide_invoice_no_upon_billing_approval = "true";
          previousConfig[rule.rule_type].ask_to_provide_invoice_no_upon_billing_approval = "true";
        }
        if (isEmpty(subConfig.skip_dim_values)) {
          subConfig.skip_dim_values = "false";
          previousConfig[rule.rule_type].skip_dim_values = "false";
        }
        if (isEmpty(subConfig.consider_driver_rates_from_billing)) {
          subConfig.consider_driver_rates_from_billing = "false";
          previousConfig[rule.rule_type].consider_driver_rates_from_billing = "false";
        }
        if (isEmpty(subConfig.allow_duplicate_zipcodes)) {
          subConfig.allow_duplicate_zipcodes = "false";
          previousConfig[rule.rule_type].allow_duplicate_zipcodes = "false";
        }
        if (isEmpty(subConfig.allow_duplicate_distances)) {
          subConfig.allow_duplicate_distances = "false";
          previousConfig[rule.rule_type].allow_duplicate_distances = "false";
        }
        if (isEmpty(subConfig.consider_special_charges)) {
          subConfig.consider_special_charges = "false";
          previousConfig[rule.rule_type].consider_special_charges = "false";
        }
        if (isEmpty(subConfig.send_dunning_invoices_from_the_beginning)) {
          subConfig.send_dunning_invoices_from_the_beginning = "false";
          previousConfig[rule.rule_type].send_dunning_invoices_from_the_beginning = "false";
        }
        if (isEmpty(subConfig.customize_transportation_invoice_line)) {
          subConfig.customize_transportation_invoice_line = "false";
          previousConfig[rule.rule_type].customize_transportation_invoice_line = "false";
        }
        if (isEmpty(subConfig.transportation_invoice_line_label)) {
          subConfig.transportation_invoice_line_label = "los_name";
          previousConfig[rule.rule_type].transportation_invoice_line_label = "los_name";
        }
        if (subConfig.transportation_invoice_line_label === "custom") {
          if (isEmpty(subConfig.pickup_line_name)) {
            subConfig.pickup_line_name = "Transportation Charges";
            previousConfig[rule.rule_type].pickup_line_name = "Transportation Charges";
          }
          if (isEmpty(subConfig.delivery_line_name)) {
            subConfig.delivery_line_name = "Transportation Charges";
            previousConfig[rule.rule_type].delivery_line_name = "Transportation Charges";
          }
          if (isEmpty(subConfig.linehaul_line_name)) {
            subConfig.linehaul_line_name = "Transportation Charges";
            previousConfig[rule.rule_type].linehaul_line_name = "Transportation Charges";
          }
        }
        if (isEmpty(subConfig.enable_re_billing)) {
          subConfig.enable_re_billing = 'NONE';
          previousConfig[rule.rule_type].enable_re_billing = 'NONE';
        }
        if (isEmpty(subConfig.allow_document_upload_on_invoice_locked)) {
          subConfig.allow_document_upload_on_invoice_locked = "false";
          previousConfig[rule.rule_type].allow_document_upload_on_invoice_locked = "false";
        }
        if (isEmpty(subConfig.multiple_invoice_lines_in_order)) {
          subConfig.multiple_invoice_lines_in_order = "false";
          previousConfig[rule.rule_type].multiple_invoice_lines_in_order = "false";
        }
        if (!subConfig?.check_screen) {
          subConfig.check_screen = "false";
          previousConfig[rule.rule_type].check_screen = "false";
        }
        if (!subConfig?.billing_for_exception_orders) {
          subConfig.billing_for_exception_orders = "true";
          previousConfig[rule.rule_type].billing_for_exception_orders = "true";
        }
        // if (!subConfig?.post_reapproved_invoices_to_qb) {
        //   subConfig.post_reapproved_invoices_to_qb = "true";
        //   previousConfig[rule.rule_type].post_reapproved_invoices_to_qb = "true";
        // }
        if (!subConfig?.ds_rate_sheet_config) {
          subConfig.ds_rate_sheet_config = "false";
          previousConfig[rule.rule_type].ds_rate_sheet_config = "false";
        }
        if (!subConfig?.display_driver_set_reports_by) {
          subConfig.display_driver_set_reports_by = "weekly";
          previousConfig[rule.rule_type].display_driver_set_reports_by = "weekly"
        }
        if (!subConfig?.rebill_credit_memo_clearance) {
          subConfig.rebill_credit_memo_clearance = "false";
          previousConfig[rule.rule_type].rebill_credit_memo_clearance = "false";
        }
        // if (!subConfig?.qb_posting_for) {
        //   subConfig.qb_posting_for = [];
        //   previousConfig[rule.rule_type].qb_posting_for = [];
        // }
        if (isEmpty(subConfig.require_fields_as_mandatory)) {
          subConfig.require_fields_as_mandatory = "";
          previousConfig[rule.rule_type].require_fields_as_mandatory = "";
        } 
        if (!subConfig?.require_on_hand_receipt) {
          subConfig.require_on_hand_receipt = "false";
          previousConfig[rule.rule_type].require_on_hand_receipt = "false";
        }
        if (!subConfig?.send_invoice_email_immediately_on_approval) {
          subConfig.send_invoice_email_immediately_on_approval = "false";
          previousConfig[rule.rule_type].send_invoice_email_immediately_on_approval = "false";
        }
        if (!subConfig?.on_hand_warehouse) {
          subConfig.on_hand_warehouse = "ALL";
          previousConfig[rule.rule_type].on_hand_warehouse = "ALL";
        }
        if (!subConfig?.on_hand_receipt_template) {
          subConfig.on_hand_receipt_template = "NONE";
          previousConfig[rule.rule_type].on_hand_receipt_template = "NONE";
        }
        if (!subConfig?.enable_global_search) {
          subConfig.enable_global_search = "false";
          previousConfig[rule.rule_type].enable_global_search = "false";
        }
          if( !subConfig?.enable_expedite_sharp_billing){
          subConfig.enable_expedite_sharp_billing = "true";
          previousConfig[rule.rule_type].enable_expedite_sharp_billing = "true";
        }
        if (!subConfig?.consider_effective_from_date) {
          subConfig.consider_effective_from_date = "false";
          previousConfig[rule.rule_type].consider_effective_from_date = "false";
        }
        if (!subConfig?.persist_filter_selection) {
          subConfig.persist_filter_selection = "true";
          previousConfig[rule.rule_type].persist_filter_selection = "true";
        }

        if (!subConfig?.use_org_linehaul_los) {
          subConfig.use_org_linehaul_los = "false";
          previousConfig[rule.rule_type].use_org_linehaul_los = "false";
        }
        
        if (!subConfig?.edi_status_filter_and_invoice_trigger) {
          subConfig.edi_status_filter_and_invoice_trigger = "false";
          previousConfig[rule.rule_type].edi_status_filter_and_invoice_trigger = "false";
        }
        if (!subConfig?.is_debit_memo_enabled) {
          subConfig.is_debit_memo_enabled = "false";
          previousConfig[rule.rule_type].is_debit_memo_enabled = "false";
        }

        if (!subConfig?.auto_completion_linehaul_pickups) {
          subConfig.auto_completion_linehaul_pickups = "false";
          previousConfig[rule.rule_type].auto_completion_linehaul_pickups = "false";
        }

        if (!subConfig?.auto_completion_order_lh_destination_wh) {
          subConfig.auto_completion_order_lh_destination_wh = "false";
          previousConfig[rule.rule_type].auto_completion_order_lh_destination_wh = "false";
        }
        
        if (!subConfig?.close_address_details_model_when_web_address_selected) {
          subConfig.close_address_details_model_when_web_address_selected = "false";
          previousConfig[rule.rule_type].close_address_details_model_when_web_address_selected = "false";
        }

        if (!subConfig?.disable_driver_settlements_for_rebilled_orders) {
          subConfig.disable_driver_settlements_for_rebilled_orders = "false";
          previousConfig[rule.rule_type].disable_driver_settlements_for_rebilled_orders = "false";
        }
        if (!subConfig?.hide_assign_now_option_for_quick_dispatch) {
          subConfig.hide_assign_now_option_for_quick_dispatch = "false";
          previousConfig[rule.rule_type].hide_assign_now_option_for_quick_dispatch = "false";
        }

        if (!subConfig?.require_paperwork_approval_for_billing) {
          subConfig.require_paperwork_approval_for_billing = "false";
          previousConfig[rule.rule_type].require_paperwork_approval_for_billing = "false";
        }

         if (!subConfig?.special_cal_for_completed_orders) {
          if(currentOrg !=="LYKES"){
            subConfig.special_cal_for_completed_orders = "service_end_time";
            previousConfig[rule.rule_type].special_cal_for_completed_orders = "service_end_time";
          }else{
            subConfig.special_cal_for_completed_orders = "appointment_start_time";
            previousConfig[rule.rule_type].special_cal_for_completed_orders = "appointment_start_time";
          }
        }
        if (!subConfig?.account_required_for_master_check_creation) {
          subConfig.account_required_for_master_check_creation = "false";
          previousConfig[rule.rule_type].account_required_for_master_check_creation = "false";
        }

        if (!subConfig?.attach_documents_to_invoices) {
          subConfig.attach_documents_to_invoices = "false";
          previousConfig[rule.rule_type].attach_documents_to_invoices = "false";
        }

        if (!subConfig?.enable_split_order) {
          subConfig.enable_split_order = "false";
          previousConfig[rule.rule_type].enable_split_order = "false";
        }
        if (!subConfig?.consider_due_date_for_aging_report) {
          subConfig.consider_due_date_for_aging_report = "false";
          previousConfig[rule.rule_type].consider_due_date_for_aging_report = "false";
        }
        
        if (!subConfig?.default_account_for_import_orders) {
          subConfig.default_account_for_import_orders = "";
          previousConfig[rule.rule_type].default_account_for_import_orders = "";
        }

      }
    });
    previousConfig[rule.rule_type] = subConfig;
    config[rule.rule_type] = subConfig;
  });
  return { updatedConfig: config, backupConfig: previousConfig };
};


export const getHighestStartDateRecord = (contracts) => {
  const rec = contracts.reduce((prev, current) => {
    const prevStartDate = moment(prev.effective_start_date);
    const currentStartDate = moment(current.effective_start_date);
    return prevStartDate.isBefore(currentStartDate) ? current : prev;
  });
  return rec;
}